var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "forest"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9402_59723",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9402_59723)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vector",
    d: "M7.79929 20.6992V17.9992H2.84929C2.49929 17.9992 2.23679 17.8451 2.06179 17.5367C1.88679 17.2284 1.89096 16.9242 2.07429 16.6242L5.02429 11.9992C4.70763 11.9992 4.47429 11.8659 4.32429 11.5992C4.17429 11.3326 4.18263 11.0659 4.34929 10.7992L8.82429 3.62422C9.00763 3.34089 9.26596 3.19922 9.59929 3.19922C9.93263 3.19922 10.191 3.34089 10.3743 3.62422L11.9993 6.24922L13.6243 3.62422C13.8076 3.34089 14.066 3.19922 14.3993 3.19922C14.7326 3.19922 14.991 3.34089 15.1743 3.62422L19.6493 10.7992C19.816 11.0659 19.8243 11.3326 19.6743 11.5992C19.5243 11.8659 19.291 11.9992 18.9743 11.9992L21.9243 16.6242C22.1076 16.9242 22.1118 17.2284 21.9368 17.5367C21.7618 17.8451 21.4993 17.9992 21.1493 17.9992H16.1993V20.6992C16.1993 20.9492 16.1118 21.1617 15.9368 21.3367C15.7618 21.5117 15.5493 21.5992 15.2993 21.5992H13.4993C13.2493 21.5992 13.0368 21.5117 12.8618 21.3367C12.6868 21.1617 12.5993 20.9492 12.5993 20.6992V17.9992H11.3993V20.6992C11.3993 20.9492 11.3118 21.1617 11.1368 21.3367C10.9618 21.5117 10.7493 21.5992 10.4993 21.5992H8.69929C8.44929 21.5992 8.23679 21.5117 8.06179 21.3367C7.88679 21.1617 7.79929 20.9492 7.79929 20.6992ZM16.8493 16.1992H19.4993L15.6993 10.1992H17.1493L14.3993 5.79922L13.0493 7.94922L14.8493 10.7992C15.016 11.0659 15.0243 11.3326 14.8743 11.5992C14.7243 11.8659 14.491 11.9992 14.1743 11.9992L16.8493 16.1992ZM4.47429 16.1992H14.7243L10.8993 10.1992H12.3493L9.59929 5.79922L6.84929 10.1992H8.29929L4.47429 16.1992ZM4.47429 16.1992H7.97429H6.47429H12.1493H10.6493H14.7243H4.47429ZM16.8493 16.1992H13.9493H16.1993H13.1243H17.5493H16.8493Z",
    fill: "#1F6CF9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForest);
export default __webpack_public_path__ + "static/media/forest.016efa0339f34118507e1e68fea94dd9.svg";
export { ForwardRef as ReactComponent };